export const environment = {
    production: false,
    apiUrl: "/api/",
    storageApi: "/storage/",
    mapsKey: "AIzaSyDiYdCTgMUVx7CcbsUc-qSjFYJlRVAY5OA",
    updateToken: "41b6d475-badc-494f-b98a-6dcea788e8c9",
};
